module.exports = __webpack_public_path__ + "static/media/acura-headset.4f76fd28.svg";